"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MilestoneInlineStatusDropdown;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
const TasksGlobalController_1 = require("./TasksGlobalController");
/**
 * Szybka zmiana statusu kamienia milowego (dropdown) — analogicznie do zadania.
 * Aktualizuje tylko pole `status` (fieldsToUpdate), więc backend pomija operacje GD/Scrum.
 * Mutuje obiekt milestone (współdzielony z drzewem) + lokalny stan, by zmiana była widoczna od razu.
 */
function MilestoneInlineStatusDropdown({ milestone }) {
    const [status, setStatus] = (0, react_1.useState)(milestone.status);
    const [saving, setSaving] = (0, react_1.useState)(false);
    const statuses = Object.values(MainSetupReact_1.default.MilestoneStatus);
    async function changeStatus(newStatus) {
        if (newStatus === status)
            return;
        try {
            setSaving(true);
            await TasksGlobalController_1.milestonesRepository.editItem({ ...milestone, status: newStatus }, undefined, ["status"]);
            milestone.status = newStatus;
            setStatus(newStatus);
        }
        catch (err) {
            console.error("Błąd zmiany statusu kamienia:", err);
        }
        finally {
            setSaving(false);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Dropdown, { onClick: (e) => e.stopPropagation() },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { as: "span", role: "button", bsPrefix: "scrum-status-toggle" },
            status && react_1.default.createElement(CommonComponents_1.MilestoneStatusBadge, { status: status }),
            saving && " …"),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, statuses.map((s) => (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: s, active: s === status, onClick: () => changeStatus(s) }, s))))));
}
